<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
    <g>
      <path
        d="M 12 2 C 11.2 2 10.5 2.7 10.5 3.5 L 10.5 4.1875 C 7.3424666 4.8700668 5 7.6215005 5 11 L 5 15.5 L 3 17.8125 L 3 19 L 21 19 L 21 17.8125 L 19 15.5 L 19 11 C 19 7.6215005 16.657533 4.8700668 13.5 4.1875 L 13.5 3.5 C 13.5 2.7 12.8 2 12 2 z M 10 20 C 10 21.1 10.9 22 12 22 C 13.1 22 14 21.1 14 20 L 10 20 z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "category",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
